import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var path = process.env.VUE_APP_BASE_API;
import { updateSysDictionaryDetail, findSysDictionaryDetail } from '@/api/sysDictionaryDetail'; //  此处请自行替换地址

import { mapGetters } from 'vuex';
import infoList from '@/mixins/infoList';
import UploadImage from '@/components/upload/image';

var _this;

export default {
  name: 'OilTicketShareConfig',
  components: {
    UploadImage: UploadImage
  },
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  data: function data() {
    return {
      editable: false,
      // 控制是否可编辑
      formData: {
        isPress: true,
        fileSize: 300,
        marks: {
          300: '300KB',
          1024: '1M',
          2048: '2M'
        },
        logoDictRow: {},
        titleDictRow: {}
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示都会调用
              console.log('activated');

              _this2.init();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var logoDictRow, titleDictRow;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.filterDictItem(1, 'oilTicketShare');

              case 2:
                logoDictRow = _context3.sent;
                _context3.next = 5;
                return findSysDictionaryDetail({
                  ID: logoDictRow.ID
                });

              case 5:
                logoDictRow = _context3.sent;
                _this3.formData.logoDictRow = logoDictRow.data.resysDictionaryDetail;
                _context3.next = 9;
                return _this3.filterDictItem(2, 'oilTicketShare');

              case 9:
                titleDictRow = _context3.sent;
                _context3.next = 12;
                return findSysDictionaryDetail({
                  ID: titleDictRow.ID
                });

              case 12:
                titleDictRow = _context3.sent;
                _this3.formData.titleDictRow = titleDictRow.data.resysDictionaryDetail;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 保存编辑
    saveEdit: function saveEdit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res, res2;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return updateSysDictionaryDetail(_this4.formData.logoDictRow);

              case 2:
                res = _context4.sent;
                _context4.next = 5;
                return updateSysDictionaryDetail(_this4.formData.titleDictRow);

              case 5:
                res2 = _context4.sent;

                if (!(res.code != 0 || res2.code != 0)) {
                  _context4.next = 9;
                  break;
                }

                _this4.$message({
                  type: 'error',
                  message: '更新失败'
                });

                return _context4.abrupt("return");

              case 9:
                _this4.$message({
                  type: 'success',
                  message: '更新成功'
                });

                _this4.editable = false;

                _this4.init();

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 上传成功
    imgUploadSuccess: function imgUploadSuccess(res) {
      this.formData.logoDictRow.label = res.data.file.url;
      this.editable = true;
      this.$forceUpdate();
    }
  }
};